import { render, staticRenderFns } from "./faysalComponent.vue?vue&type=template&id=030a8090&"
import script from "./faysalComponent.vue?vue&type=script&lang=js&"
export * from "./faysalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports